export function IconDetail({ icon, label, className = '' }) {
  return (
    <div className={`inline-flex items-center gap-1.5 text-sm text-neutral-700 ${className}`}>
      <span className="text-neutral-500">{icon}</span>
      <span>{label}</span>
    </div>
  )
}

export const icons = {
  bed: '🛏',
  bath: '🚿',
  area: '📐',
  location: '📍',
  price: '💰',
  calendar: '📅',
  construction: '🏗',
  document: '📄',
  check: '✓',
  home: '🏠',
  following: '👀',
  reserved: '📋',
  clock: '⏰',
}
